import { render, staticRenderFns } from "./unsupportedbrowser.vue?vue&type=template&id=3dd9ea9b&lang=pug&"
import script from "./unsupportedbrowser.vue?vue&type=script&lang=js&"
export * from "./unsupportedbrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd9ea9b')) {
      api.createRecord('3dd9ea9b', component.options)
    } else {
      api.reload('3dd9ea9b', component.options)
    }
    module.hot.accept("./unsupportedbrowser.vue?vue&type=template&id=3dd9ea9b&lang=pug&", function () {
      api.rerender('3dd9ea9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/errors/unsupportedBrowser/unsupportedbrowser.vue"
export default component.exports